import { environment } from '../../../environments/environment';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  computed,
  input,
} from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { ContentFooter, ContentMenu } from '../../models/content/content';
import { User } from '../../models/user/user';
import { AuthService } from '../../services/auth/auth.service';
import { ContentService } from '../../services/content/content.service';
import { IconService } from '../../services/icon/icon.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false,
})
export class MenuComponent implements OnInit, OnDestroy {
  @Output() menuClosed: EventEmitter<any> = new EventEmitter();

  currentUser = input<User | null>(null);
  currentUserName = computed(() => {
    const user = this.currentUser();
    if (user) {
      return [user.givenName, user.familyName].join(' ');
    }
    return '';
  });
  adminLabel = computed(() => {
    const user = this.currentUser();
    if (user?.roles?.includes('ADMIN')) {
      return $localize`Admin`;
    } else if (user?.roles?.includes('REGION_ADMIN')) {
      return $localize`Regio Admin`;
    }
    return $localize`Admin`;
  });

  contentFooter: ContentFooter;
  contentMenu: ContentMenu;
  contentImage: string;
  brandedIcons = this.iconService.getBrandedIcons();
  numberOfAcceptedOrganisationCallsInMenu =
    environment.numberOfAcceptedOrganisationCallsInMenu;
  menuPlatformPosition = 1;
  menuItemsOpen: string[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private authService: AuthService,
    private contentService: ContentService,
    private iconService: IconService,
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // Load menu items open state from safe storage
    this.menuItemsOpen = this.localStorageService.getItem<string[]>(
      'menuItemsOpen',
      [],
    );

    // Get the content
    this.contentFooter = this.contentService.getContentByPath('footer');
    this.contentMenu = this.contentService.getContentByPath('menus.full');
    this.contentImage = this.contentService.getContentByPath('menus.fullImage');
    this.menuPlatformPosition =
      this.contentService.getContentByPath(
        'menus.fullscreenPlatformPosition',
      ) || 1;
  }

  /** Signs out the current user */
  signout() {
    // Effectively sign out
    this.authService.signout();

    // Navigate to the homepage
    this.router.navigateByUrl('/');

    // Close the menu
    this.menuClosed.emit();
  }

  toggleMenuItem(label: string) {
    if (this.menuItemsOpen.includes(label)) {
      this.menuItemsOpen = this.menuItemsOpen.filter((item) => item !== label);
    } else {
      this.menuItemsOpen.push(label);
    }
    this.localStorageService.setItem('menuItemsOpen', this.menuItemsOpen);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
